import { css } from '@emotion/css';

export const flashCardContainerStyles = css`
  .flip-card {
    background-color: transparent;
    width: 28.8rem;
    height: 36rem;
    perspective: 1000px;
  }

  .flip-card-inner {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 0.6s;
    transform-style: preserve-3d;
  }

  .flip-card-front,
  .flip-card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }

  .flip-card-back {
    transform: rotateY(180deg);
  }
`;

export const transFormStyles = css`
  .flip-card-inner {
    transform: rotateY(180deg);
  }
`;

export const zIndexStyles = (zIndex: number) => css`
  z-index: ${zIndex};
`;
